import React, {useEffect, useState} from "react";
import {FaPlus, FaTrash} from "react-icons/fa";
import './AssignPhoneNumbers.css';
import apiClient from "../axios/axiosInterceptor";

function AssignPhoneNumbers({project, onClose, onSubmit}) {
    const [phoneNumbers, setPhoneNumbers] = useState([""]);

    useEffect(() => {
        if (project) {
            const fetchPhoneNumbers = async () => {
                try {
                    const url = `/tenants/${project.tenantId}/projects/${project.id}/phones`;
                    const response = await apiClient.get(url);
                    setPhoneNumbers(response.data.list);
                } catch (error) {
                    console.error("Error fetching phone numbers:", error);
                }
            };

            fetchPhoneNumbers();
        }
    }, []);
    const handleAddPhoneNumber = () => {
        setPhoneNumbers([...phoneNumbers, ""]);
    };

    const handlePhoneNumberChange = (index, value) => {
        const newPhoneNumbers = [...phoneNumbers];
        newPhoneNumbers[index] = value;
        setPhoneNumbers(newPhoneNumbers);
    };

    const handleDeletePhoneNumber = (index) => {
        const newPhoneNumbers = phoneNumbers.filter((_, i) => i !== index);
        setPhoneNumbers(newPhoneNumbers);
    };

    const handleSubmit = e => {
        e.preventDefault();
        onSubmit(Array.from(phoneNumbers));
    };

    return (
        <div className="modal">
            <div className="modal-content modal-content animate__animated animate__zoomIn">
                <span className="close" onClick={onClose}>&times;</span>
                <form onSubmit={handleSubmit} className="phone-number-form">
                    <h2>Assign Phones</h2>
                    {phoneNumbers.map((phoneNumber, index) => (
                        <div key={index} className="phone-number-row">
                            <label>Phone Number {index + 1}</label>
                            <div className="phone-number-input">
                                <input
                                    type="text"
                                    value={phoneNumber}
                                    onChange={(e) => handlePhoneNumberChange(index, e.target.value)}
                                />
                                <FaTrash className="delete-icon" onClick={() => handleDeletePhoneNumber(index)}/>
                                {index === phoneNumbers.length - 1 && (
                                    <FaPlus className="add-icon" onClick={handleAddPhoneNumber}/>
                                )}
                            </div>
                        </div>
                    ))}
                    {phoneNumbers.length === 0 && (
                        <FaPlus className="add-icon" onClick={handleAddPhoneNumber}/>
                    )}
                    <button type="submit" className="create-button">Submit</button>
                </form>
            </div>
        </div>
    );
}

export default AssignPhoneNumbers;
